export default __webpack_public_path__ + "static/media/icon-settings.95d8b0bd.svg";